import React from 'react';
import map from '../../assets/svgs/map.svg';
const OperationalAreas    = () => {
    return (
        <div style={{backgroundColor: '#EAF7FF',margin: '18px 50px',borderRadius: '20px',paddingLeft: '50px',paddingTop: '60px'}} className=''>
            
            <div className='row'>
                <div className='col-md-12'>
                    <h1 style={{fontWeight: '700', color: '#006FB4',fontFamily: 'Montserrat',fontSize: '62px'}} >Operational Areas</h1>
                </div>
                <div className='col-md-3 mt-3' >
                    <p style={{fontWeight: '500', color: 'black',fontFamily: 'Montserrat',fontSize: '18px'}} >
                    We provide everything from Drayage <br></br> to Trans-loading to Cross Docking.
                    </p>
                    <button className='thm-btn mt-4' style={{fontWeight: '500',fontFamily: 'Montserrat',fontSize: '16px',backgroundColor: '#006FB4',padding: '12px 24px',color: 'white',marginTop: '10px'}} >
                    View in detail
                    <i className='fa fa-arrow-right'></i>
                    </button>
                </div>
                <div className='col-md-9' style={{marginTop: '-180px'}} >
                    <img  className='img-fluid img-responsive' src={map} alt='map' width={'100%'} style={{height: '100%'}} />
                </div>
            </div>



        </div>
    );
}

export default OperationalAreas
;


